import type * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 48px 32px;
  max-width: 900px;
  margin: auto;
`;

export interface OnPageResultContainerProps {
  children: React.ReactNode;
}

export function OnPageResultContainer(props: OnPageResultContainerProps) {
  return <Container>{props.children}</Container>;
}
